export const FunSun = 'SM';
